import { useMemo } from 'react';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { ProjectDto } from '@/core';

export type FormValueType = {
  name: string;
  description: string;
};

export const useSchemaEpic = (projectData: ProjectDto, initialValue: FormValueType) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'projects.constructor' });
  const existingEpics = projectData.epics
    .map((epic) => epic.name?.toLocaleLowerCase())
    .filter((epic) => epic !== initialValue?.name?.toLocaleLowerCase());

  return useMemo(
    () =>
      Yup.object().shape({
        name: Yup.string()
          .nullable()
          .required()
          .lowercase()
          .notOneOf(existingEpics, t('addEpics.epic.existing'))
          .max(250),
        description: Yup.string().nullable().max(400),
      }),
    [t, existingEpics],
  );
};
